<template>
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0996 11C12.3559 11 12.6018 11.102 12.7828 11.2834L16.7843 15.2929C17.1742 15.6835 17.1738 16.3162 16.7836 16.7064L16.7064 16.7836C16.3162 17.1738 15.6835 17.1742 15.2929 16.7843L11.2834 12.7828C11.102 12.6018 11 12.3559 11 12.0996V11.8265C11 11.7517 10.971 11.6799 10.9192 11.6262C10.813 11.5161 10.6397 11.5085 10.5197 11.6033C9.4107 12.4791 8.01273 13 6.5 13C2.91 13 0 10.09 0 6.5C0 2.91 2.91 0 6.5 0C10.09 0 13 2.91 13 6.5C13 8.01273 12.4791 9.4107 11.6033 10.5197C11.5085 10.6397 11.5161 10.813 11.6262 10.9192C11.6799 10.971 11.7517 11 11.8265 11H12.0996ZM2 6.5C2 8.99 4.01 11 6.5 11C8.99 11 11 8.99 11 6.5C11 4.01 8.99 2 6.5 2C4.01 2 2 4.01 2 6.5Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
